import { Popconfirm } from 'antd'
import { t } from 'i18next'
import type { FC, ReactElement } from 'react'

export const PopconfirmIf: FC<{
  children: ReactElement
  condition: boolean
  title: ReactElement
  onConfirm: () => void
  okText?: string
}> = ({ children, condition, title, onConfirm, okText }) => {
  if (condition) {
    return (
      <Popconfirm onConfirm={onConfirm} okText={okText ?? t(`はい`)} title={title}>
        {children}
      </Popconfirm>
    )
  }

  return <>{children}</>
}
